(function () {
  function setPressed(buttons, active) {
    buttons.forEach(function (button) {
      var on = button === active;
      button.classList.toggle('is-active', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var filter = event.target.closest('[data-pc-filter]');
    if (filter) {
      var section = filter.closest('[data-pc-featured]');
      if (!section) return;
      setPressed(section.querySelectorAll('[data-pc-filter]'), filter);
      var name = filter.getAttribute('data-pc-filter');
      var visible = 0;
      section.querySelectorAll('[data-pc-card]').forEach(function (card) {
        var tags = (card.getAttribute('data-tags') || '').split(',');
        var show = name === 'all' || tags.indexOf(name) !== -1;
        card.hidden = !show;
        if (show) visible += 1;
      });
      var empty = section.querySelector('[data-pc-filter-empty]');
      if (empty) empty.hidden = visible !== 0;
      return;
    }

    var pack = event.target.closest('[data-pc-pack]');
    if (pack) {
      var card = pack.closest('[data-pc-card]') || pack.closest('form') || document;
      setPressed(card.querySelectorAll('[data-pc-pack]'), pack);
      var price = card.querySelector('[data-pc-price]');
      if (price) price.textContent = pack.getAttribute('data-price') || '';
      var compare = card.querySelector('[data-pc-compare]');
      if (compare) {
        var compareText = pack.getAttribute('data-compare') || '';
        compare.hidden = compareText === '';
        compare.textContent = compareText;
      }
      var per = card.querySelector('[data-pc-per-gal]');
      if (per) {
        var perText = pack.getAttribute('data-per-gallon') || '';
        per.hidden = perText === '';
        per.textContent = perText;
      }
      var freight = card.querySelector('[data-pc-freight]');
      if (freight) freight.hidden = pack.getAttribute('data-freight') !== 'true';
      var input = card.querySelector('[data-pc-variant-input]');
      if (input) input.value = pack.getAttribute('data-variant-id');
      var sku = card.querySelector('.pc-card__meta span');
      if (sku && pack.getAttribute('data-sku')) sku.textContent = pack.getAttribute('data-sku');
      return;
    }

    var tab = event.target.closest('[data-pc-tabs] [role="tab"]');
    if (tab) {
      activateTab(tab);
      return;
    }

    var faqButton = event.target.closest('[data-pc-faq] [data-pc-faq-button]');
    if (faqButton) {
      var open = faqButton.getAttribute('aria-expanded') === 'true';
      var panel = document.getElementById(faqButton.getAttribute('aria-controls'));
      faqButton.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (panel) panel.hidden = open;
    }
  });

  function activateTab(tab) {
    var tabs = tab.closest('[data-pc-tabs]');
    if (!tabs) return;
    var targetId = tab.getAttribute('aria-controls');
    tabs.querySelectorAll('[role="tab"]').forEach(function (item) {
      var on = item === tab;
      item.classList.toggle('is-active', on);
      item.setAttribute('aria-selected', on ? 'true' : 'false');
      item.tabIndex = on ? 0 : -1;
    });
    tabs.querySelectorAll('[role="tabpanel"]').forEach(function (panel) {
      var on = Boolean(targetId) && panel.id === targetId;
      if (on) {
        panel.removeAttribute('hidden');
        panel.hidden = false;
      } else {
        panel.setAttribute('hidden', '');
        panel.hidden = true;
      }
      panel.classList.toggle('is-active', on);
    });
  }

  document.addEventListener('keydown', function (event) {
    var tab = event.target.closest('[data-pc-tabs] [role="tab"]');
    if (!tab) return;
    var keys = ['ArrowRight', 'ArrowLeft', 'Home', 'End'];
    if (keys.indexOf(event.key) === -1) return;
    var list = tab.closest('[role="tablist"]');
    if (!list) return;
    var items = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
    var index = items.indexOf(tab);
    var next = index;
    if (event.key === 'ArrowRight') next = (index + 1) % items.length;
    if (event.key === 'ArrowLeft') next = (index - 1 + items.length) % items.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = items.length - 1;
    event.preventDefault();
    items[next].focus();
    activateTab(items[next]);
  });

  document.addEventListener('change', function (event) {
    var subscribe = event.target.closest('[data-pc-subscribe]');
    if (!subscribe) return;
    var form = subscribe.closest('form');
    if (!form) return;
    var field = form.querySelector('[data-pc-selling-plan]');
    if (!field) return;
    if (subscribe.checked) {
      field.disabled = false;
      field.value = subscribe.getAttribute('data-selling-plan') || '';
    } else {
      field.disabled = true;
      field.value = '';
    }
  });

  document.querySelectorAll('[data-pc-card] [data-pc-pack].is-active').forEach(function (pack) {
    pack.click();
  });

  document.querySelectorAll('[data-pc-tabs]').forEach(function (tabs) {
    var active = tabs.querySelector('[role="tab"].is-active') || tabs.querySelector('[role="tab"]');
    if (active) activateTab(active);
  });

  document.querySelectorAll('form[role="search"]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var scope = form.querySelector('[data-pc-search-scope]');
      var input = form.querySelector('input[name="q"]');
      if (!scope || !input || !scope.value) return;
      var token = 'tag:' + scope.value;
      if (input.value.indexOf(token) === -1) {
        input.value = (input.value + ' ' + token).trim();
      }
    });
  });

  var sdsSearch = document.querySelector('[data-pc-sds-search]');
  if (sdsSearch) {
    sdsSearch.addEventListener('input', function () {
      var query = sdsSearch.value.toLowerCase();
      document.querySelectorAll('[data-pc-sds-row]').forEach(function (row) {
        row.hidden = row.textContent.toLowerCase().indexOf(query) === -1;
      });
    });
  }
})();
